import { render, staticRenderFns } from "./sources-dialog.vue?vue&type=template&id=06c03331&"
import script from "./sources-dialog.vue?vue&type=script&lang=js&"
export * from "./sources-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports